import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode } from "swiper/modules";
import scrollOne from "../../assets/images/scollOne.webp"
import scrollTwo from "../../assets/images/scrollTwo.webp"
import scrollThree from "../../assets/images/scrollThree.webp"
import scrollFour from "../../assets/images/scrollFour.webp"
import scrollFive from "../../assets/images/scrollFive.webp"
import scrollSix from "../../assets/images/scrollSix.webp"
import productOne from "../../assets/images/productOne.webp"
import productTwo from "../../assets/images/productTwo.webp"

import "swiper/css";

export default function OliveSwiper() {
  const slides = [productOne, productTwo, scrollOne, scrollTwo, scrollThree,scrollFour,scrollFive,scrollSix];

  // create enough slides for smooth looping
  const loopSlides = [...slides, ...slides, ...slides];

  return (
    <div className="oliveSwiper">
    <Swiper
      modules={[Autoplay]}
      slidesPerView={4}
      centeredSlides={true}
      loop={true}
      loopedSlides={loopSlides.length}
      spaceBetween={20}

      speed={3000}                // 🔥 continuous smooth motion
      allowTouchMove={false}      // 🔥 prevents snapping issues

      autoplay={{
        delay: 0,                 // 🔥 NO DELAY → continuous scroll
        disableOnInteraction: false,
      }}
    >
      {loopSlides.map((i, index) => (
        <SwiperSlide key={index}>
          <div className="slideCard">
            <img src={i} alt="" />
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  </div>
  );
}